import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { IGetPermissionGroups } from "@shared/lib/types/permissions";
import { PoliciesService } from "../services/policies.service";

export const useEditPermissionGroup = (queryKey?: any) => {
  const {
    mutate: editPermissionGroup,
    isLoading: isPermissionGroupEditing,
    isSuccess: isPermissionGroupEdited,
    error: permissionGroupEditError,
  } = useMutation({
    mutationFn: (payload: {
      brandOrganisationId: string;
      permissionGroupId: string;
      name: string;
      permissions: string[];
      description?: string;
    }) => PoliciesService.editPermissionGroup(payload),

    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      // c.invalidateQueries({
      //   queryKey: [...PERMISSION_GROUPS_QUERY_KEY, params.brandOrganisationId],
      // });
      if (queryKey) {
        c.setQueryData(
          queryKey,
          (oldData: BackednResponse<IGetPermissionGroups>) => ({
            ...oldData,
            data: {
              ...oldData?.data,
              data: oldData?.data?.data?.map((group) => {
                if (group._id === params.permissionGroupId) {
                  return {
                    ...group,
                    ...data.data,
                  };
                } else {
                  return group;
                }
              }),
            },
          })
        );
      }
    },
  });

  return {
    editPermissionGroup,
    isPermissionGroupEditing,
    isPermissionGroupEdited,
    permissionGroupEditError,
  };
};
